import axios from 'axios';

const apiSemolis = axios.create({
  baseURL: process.env.REACT_APP_/dev/volta/web_GO_STB_SEMOLIS,
});

export default apiSemolis;
